<template>
  <div>
    <!-- nav -->
    <versionNav></versionNav>
    <!-- 目前模块为background -->
    <section class="topBg" id="tops">
      <ul class="topBg_nav">
        <li id="dt1"></li>
        <li
          v-for="(item, index) in navList"
          :key="index"
          @click="downDown(item.id)"
        >
          <p :class="item.id == 'tops' ? 'on' : ''">{{ item.text }}</p>
          <span :class="item.id == 'tops' ? 'on' : ''">{{ item.etext }}</span>
        </li>
        <li id="dt2"></li>
      </ul>
      <div class="inner">
        <div class="versTime">{{ versTime }}</div>
        <!-- <p class="taskTitle">赏金猎人限时任务</p> -->
        <p class="taskText">{{ taskText }}</p>
        <!-- <p class="taskText2">{{taskText2}}</p> -->
        <div class="linkBox clearfix">
          <div class="downloadGame">
            <a href="https://qqsm.zygames.com/t3/download.html" target="_blank" rel="noopener noreferrer">游戏下载</a>
          </div>
          <div class="goHome">
            <a href="https://qqsm.zygames.com/main.html" target="_blank" rel="noopener noreferrer">官网首页</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 新模式 -->
    <!-- <section class="xms" id="xms"><div class="inner"></div></section> -->
    <!-- 新系统 -->
    <!-- <section class="xxt" id="xxt"><div class="inner"><h2>{{newSystem.text}}</h2><p v-html="newSystem.int"></p><a href="https://qqsm.zygames.com/info/gemIndex.html" target="_blank" rel="noopener noreferrer">查看更多</a></div></section> -->
    <!-- <slides id="xwf"></slides> -->
      

    <!-- <xxtTab id="xxt"></xxtTab> -->
    
    <!-- 新难度 -->
    <!-- <xndTab :xndData="newMaps" id="xnd"></xndTab> -->
    <!-- 新地图 -->
    <!-- <xdtTab :xdtData="newMaps" id="xdt"></xdtTab> -->
    <!-- <xbsTab id="xbs"></xbsTab> -->
    
    <!-- 新配方 -->
    <!-- <xpfTab :xpfData="newPF" id="xpf"></xpfTab> -->

    <!-- 新幻影 -->
    <xhyTab id="xhy"></xhyTab>
    <!-- 新武器 -->
    <!-- <xwqTab id="xwq"></xwqTab> -->
    <xwqTab :xwqData="newWeapon" id="xwq"></xwqTab>

    <!-- 新时装 -->
    <!-- <xszTab id="xsz"></xszTab> -->
    <!-- <xszTab :xszData="newFS" id="xsz"></xszTab> -->
    <!-- 新装置 -->
    <!-- <xbsTab id="xbs"></xbsTab> -->
    <!-- 新挂件 -->
    <!-- <xgjTab id="xgj"></xgjTab> -->
    <!-- <xgjTab :xgjData="newGJ" id="xgj"></xgjTab> -->
    <!-- 新装备 -->
    <!-- <section class="xzb" id="xzb"></section> -->

    <!-- 新变身装置 -->
    <!-- <xbsTab id="xbs"></xbsTab> -->
    <!-- 新插件/装置 -->
    <!-- <xcjTab id="xcj"></xcjTab> -->
    <!-- 新道具 -->
    <!-- <xdjTab id="xdj"></xdjTab> -->

    <!-- 新机友 -->
    <!-- <uavTab id="uav"></uavTab> -->
    <!-- 新僚机系统 -->
    <!-- <xljTab id="xlj"></xljTab> -->

    <!-- <section class="loading loading1" id="loading1"><div class="inner"><p>无限次元挑战带来时空波动，打扰到平行宇宙中的元素主宰。主宰定位到波动中心——地球。他发动元素之力在地球的三个坐标引发了元素裂隙，分别为：火焰、生化、科技。主宰派出先遣队长从裂隙中侵入，他们拥有主宰所赐的元素之力。先遣队逐渐影响和控制了地球的各种生物和科技。</p></div></section> -->
    <!-- <section class="loading loading2" id="loading2"><div class="inner"><p>为了防止主宰势力的进一步入侵，国联不但派重兵暂时控制住了三个元素裂隙，还命令战士们去四处讨伐主宰的势力，获取元素材料来不停的强化和加固裂隙。国联科学家们偶然发现可以采用共鸣的方式来让裂隙的元素之力对战士们的武器进行增幅，以敌之矛来破敌之盾。</p></div></section> -->

    

    <!-- 靶场 -->
    <versionBc id="versionBc"></versionBc>

    <!-- 周免道具 -->
    <freeProps id="freeProps"></freeProps>
    <span class="mousegif" v-show="hasScrolledBottom">
                <div class="container">
                    <div class="arrow"></div>
                    <div class="arrow"></div>
                    <div class="arrow"></div>
                </div>
            </span>
  </div>
  
</template>

<script>
import { mapGetters } from "vuex";
// import xdtTab from "../components/newItem/xdt.vue";
import xwqTab from "../components/newItem/xwq.vue";
import xhyTab from "../components/newItem/xhy.vue";
// import xpfTab from "../components/newItem/xpf.vue";
// import xszTab from "../components/newItem/xsz.vue";

// import xljTab from "../components/newItem/xlj.vue";
// import xbsTab from "../components/newItem/xbs.vue";
// import xgjTab from "../components/newItem/xgj.vue";
// import xdjTab from "../components/newItem/xdj.vue";
// import xmsTab from "../components/newItem/other.vue";
// import xxtTab from "../components/newItem/other.vue";
// import uavTab from "../components/newItem/uav.vue";

import versionBc from "../components/qqsmVersion_bc.vue";
import freeProps from "../components/freeProps.vue";
// import videoPlayer from "../components/videoPlayer.vue";
// import slides from "../components/slide.vue";

export default {
  name: "Home",
  data() {
    return {
      hasScrolledBottom: true,
      navList: [
        // { text: "新地图", etext: "New Maps", id: "xdt" },
        { text: "新幻影", etext: "New ShadowInv", id: "xhy" },
        { text: "新武器", etext: "New Weapons", id: "xwq" },
        // { text: "新时装", etext: "New Clothes", id: "xsz" },
        // { text: "新装置", etext: "New Formula", id: "xbs" },
        // { text: "新挂件", etext: "New Formula", id: "xgj" },
        // { text: "新配方", etext: "New Formula", id: "xpf" },
        // { text: "新模式", etext: "New Maps", id: "xms" },
        // { text: "新系统", etext: "New System", id: "xxt" },
        // { text: "巅峰战役", etext: "New", id: "xwf" },
        // { text: "新系统", etext: "New System", id: "xxt" },
        // { text: "新机友插件", etext: "New UAV", id: "uav" },
        // { text: "新机友", etext: "New UAV", id: "uav" },
        // { text: "新僚机", etext: "New Wingman", id: "xlj" },
        // { text: "新难度", etext: "New Difficulty", id: "xnd" },
        // { text: "新插件", etext: "New Formula", id: "xcj" },
        // { text: "新道具", etext: "New props", id: "xdj" },
        // { text: "新玩具", etext: "New props", id: "xdj" },
        // { text: "新宝石", etext: "New props", id: "xdj" },
        // { text: "新装备", etext: "New Clothes", id: "xzb" },
        // { text: "元素入侵", etext: "无限次元", id: "loading1" },
        // { text: "武器共鸣", etext: "新玩法", id: "loading2" },
        { text: "限时道具", etext: "Time-limited", id: "versionBc" },
        { text: "免费福利", etext: "Free Props", id: "freeProps" },
        { text: "回到顶部", etext: "RETURN TOP", id: "tops" },
      ],
      newWeapon: { text: "传承-侵彻之锤", id: "5617", int: "工程六部以革命性纳米复合材料重构WA2000，将枪械性能发挥至极致。枪身结构经独特优化，不但能承受大威力烈性弹药的连续冲击，还能最大程度的抵消后坐力。为此工程六部特别研制出专属侵彻子弹，使其在持续命中弱点时将造成恐怖的伤害。完美换弹后的金子弹弱点加成提升。"}
      // newSystem: {text: "云石系统", id: "0", int: "近期异次元中时空乱流产生大规模异常暴动，导致大量神秘物质从时空裂缝中溢出，部分生物受其影响发生了变异。我方侦察部队在消灭这些变异生物后，缴获了大量的神秘物质。国联军事委员会已责成工程六部成立专项研究小组对其进行研究，最终发现不同类型的神秘物质具有各自独特的增益效果，能提升不同方面的战斗能力，国联工程六部将其命名为“云石”。决定进行应用化改造，提升前线特战队的战斗力。"},
      // newMaps: { text: "火线突袭-蛇祀小镇", id: "345", int: "一个寂寂无名的江南小镇在半年前与外界失去了联系，半年后，国联在此处探测到了巨大的能量波动，并发现了大量安盟军队活动的迹象，于是派出阿尔法小队前往调查。这个小镇受到了元素领主的蛊惑，形成了信仰该元素领主的邪教，他们称呼这个元素领主为烛龙遗子。安盟更早发现了此事占领了小镇继续召唤元素领主，企图在元素领主降临后窃取它的力量。阿尔法小队跟随一个逃出小镇的灵体杀入蛇灯之中，誓要消灭盘踞其中的元素领主。"},
      // newPF: { text: "传承-哀伤之霜升阶", id: "5716", int: "7.62mm口径半自动狙击步枪，弹匣容量5发。伴随特殊合金材质的外衣，具有高伤害、高精度等优点。", drawing: "设计图：传承-哀伤之霜", did: "105712", part: "传承-哀伤之霜专属材料", pid: "2198010"}
      // newGJ: {text: "七星逐日-升华蜕变", int: "诞生于遥远的时间位面，在无数次射击下撕裂虚空贯穿轮回。其身上晦涩的铭文，蕴藏着足以毁灭恒星的神性力量。若能全力以赴，其迸发而出的业火将颠覆尘世，击碎天穹。【“暴君-七星逐日” “蓄力时间减少10%”】"},
      // newFS: {text: "福运兔娘（女）", id: "", int: "可爱白色兔耳外配同色手套，将新春贺词绣于外衣，柔滑蕾丝勾勒出婀娜多姿的曲线，腰间定制的胡萝卜可为新的一年带来福运，辞旧迎新，吉祥如意。“福运”"}
    };
  },
  created() {
    // console.log('index_created')
  },
  mounted() {
    // this.cons();
    // console.log('index_mounted')
    window.addEventListener('scroll',   this.onScroll, true);
  },
  beforeDestroy() {
   window.removeEventListener('scroll', this.onScroll, true);
  },
  destroyed() {},
  computed: {
    ...mapGetters(["versTime"]),
    ...mapGetters(["taskText"]),
    // ...mapGetters(['taskText2'])
  },
  components: {
    versionBc //靶场
    ,freeProps //免费武器
    // ,xwqTabPlay //新武器轮播
    // ,videoPlayer //新地图视频播放
    // ,slides
    // ,xdtTab //新地图
    // ,xwfTab //新玩法
    // ,xxtTab //新系统
    ,xwqTab //新武器
    ,xhyTab //新幻影
    // ,xpfTab  //新配方
    // ,xszTab  //新时装
    // ,xbsTab //新变身装置
    // ,xgjTab  //新挂件
    // ,xdjTab  //新道具
    // ,xcjTab  //新插件
    // ,xljTab  //新僚机
    // ,uavTab //新机友
  },
  methods: {
    onScroll(){
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop,
       scrollHeight  = document.body.scrollHeight  || document.documentElement.scrollHeight,
       clientHeight = document.documentElement.clientHeight;
      if(scrollTop+clientHeight<scrollHeight){
        this.hasScrolledBottom = true;
        } else {
        this.hasScrolledBottom = false;
      }
    },
    downDown(selector) {
      var anchor = this.$el.querySelector("#" + selector);
      anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    // getInt(ints) {
    //   return ints
    //     .replace(/\r\n|\n|\r|“/g, '<h6 style="font-weight:bold;color:#f00;">“')
    //     .replace(/\r\n|\n|\r|”/g, "”</h6>");
    //   // return ints.replace(/\r\n|\n|\r|“/g, "<strong style='font-weight:bold;color:#069;'>“").replace(/\r\n|\n|\r|”/g,"”</strong>");
    // },
    // getImg(id) {
    //   if (!id) {
    //   } else {
    //     return "//cdn1.zygames.com/qqsm/t1/weapon/" + id + ".png";
    //   }
    // }, //用require编译图片地址
    player() {
      this.$layer.open({
        type: 1,
        title: false,
        closeBtn: 1, //不显示关闭按钮
        shade: [0],
        area: ["600px", ""],
        skin: "blackBg",
        anim: 1,
        content: ` 
        <video class="myvideo" poster="../../static/myvideoBg.jpg" src="//cdn1.zygames.com/qqsm/video/Mars_cutscene_2.webm" width="560" height="320" preload controls></video>
      `,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.go-top {
  position: fixed;
  bottom: 120px;
  right: 20px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  z-index: 99;
}

.inner {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-top: 1px;
}

.topBg {
  background: #000 url("../assets/img/bg1.jpg") no-repeat top center;
  // height: 1065px;
  height: 100vh;
  height: 1065px;
  position: relative;
  min-width: 1200px;

  .versTime {
    height: 48px;

    // width: 340px; color: #000; background: url("../assets/img/eventime_2.png") no-repeat top center; font-size: 24px; line-height: 48px;
    width: 340px; color: #000; background: url("../assets/img/eventime0.png") no-repeat top center; font-size: 26px; line-height: 51px;
      color: #000; text-shadow: 0 0 10px #fff;
    // width: 360px; color: #fff; background: linear-gradient(to right, rgba(0,0,0,0),rgba(0,0,0,0.75),rgba(0,0,0,1),rgba(0,0,0,0.75),rgba(0,0,0,0));
    // width: 382px;height: 66px;line-height: 66px;color: #94c4f5;background: url("../assets/img/eventime1.png") no-repeat top center;
    // width: 382px;height: 54px;line-height: 54px;color: #b9f7ff; border: 3px solid #b9f7ff; border-radius: 27px; background-color:rgba(0, 117, 133, 0.25);
    // width: 340px; height: 54px; color: #bead8f; border:3px solid #bead8f; border-radius: 27px; background-color:rgba(176, 157, 125, 0.25); font:26px/54px "微软雅黑"; text-align: center;
    // background: url("../assets/img/eventime1.png") no-repeat top center;


    font-weight: bolder;
    margin-top: 550px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50px;
    padding-left: 0px;
    // background: #dfad51;
  }

  .topBg_nav {
    position: fixed;
    right: 30px;
    top: 24%;
    width: 140px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    z-index: 99999;

    li {
      width: 136px;
      height: 50px;
      display: block;
      color: #fff;
      letter-spacing: 0.1em;
      cursor: pointer;
      text-align: center;
      border-style: solid;
      border-width: 0 2px;
      border-color: #fbbe10;
      background: rgba(0, 0, 0, 0.5);

      &:hover {
        p,
        span {
          color: #fbbe10; //red;
        }
      }

      &#dt1,
      &#dt2 {
        border: 0;
        width: 140px;
        height: 50px;
        background: transparent;
      }

      &#dt1 {
        background: url("../assets/img/dt1.png") no-repeat top center;
      }

      &#dt2 {
        background: url("../assets/img/dt2.png") no-repeat top center;
      }

      p {
        padding-top: 10px;
        font-size: 18px;
        line-height: 18px;
        // float: left;
        font-weight: 600;
        font-family: Calibri, Tahoma, "Microsoft Yahei", "微软雅黑";

        // text-shadow: 2px 2px 2px #000;
        &.on {
          color: #fbbe10;
        }
      }

      span {
        width: 110px;
        margin: 0 auto;
        font-size: 11px;
        color: #ccc;
        font-family: Calibri, Tahoma, "Microsoft Himalaya", sans-serif;
        display: block;
        border-bottom: 1px solid #fbbe10;
        padding-bottom: 3px;

        &.on {
          color: #fbbe10;
        }
      }
    }
  }

  // .taskTitle {
  //   height: 40px;
  //   color: #fff;
  //   font: bold 18px/36px "微软雅黑";
  //   text-shadow: 0 0 5px #f90;
  //   line-height: 40px;
  //   background: url("../assets/img/taskTextBg1.png") no-repeat top center;
  // }
  // .taskText2 {
  //   font-size: 14px;
  //   // color: rgba(251,56,15,365);
  //   color: #ff0;
  //   // color: #fff;
  //   text-shadow: 0 0 3px #f00;
  //   text-align: center;
  //   font-weight: bold;
  //   letter-spacing: 0.1em;
  //   width: 800px;
  //   // height: 60px;
  //   // line-height: 60px;
  //   margin: 5px auto 0 auto;
  // }
  .taskText, .taskText2 {
    // color: #fc0;
    text-align: center;
    font-family: 微软雅黑, "Microsoft Yahei";
    font-weight: bold;
    
    // text-shadow: 0 0 3px #f09;
    width: 880px;
    height: 40px;
    background: url("../assets/img/taskTextBg1.png") no-repeat top center; font-size: 16px; color: #fff; text-shadow: 0 0 3px #09f;
    //背景设置为横向渐变色，从透明渐变到黄色再渐变到透明
    // background: linear-gradient(to right, rgba(255,255,0,0), rgba(255,255,0,0.2), rgba(255,255,0,1), rgba(255,255,0,0.2), rgba(255,255,0,0)); font-size: 16px; color: #fff; text-shadow: 0 0 3px #f00;
    padding-left: 0px;
    line-height: 40px;
    margin: 5px auto 0;
    letter-spacing: 0.1rem;
  }

  .linkBox {
    width: 490px;
    margin: 50px auto 0;
    padding-left: 0px;

    div {
      float: left;
      width: 200px;
      height: 60px;
      text-align: center;

      a {
        width: 200px;
        height: 60px;
        display: block;
        font-size: 20px;
        font-weight: bold;
        line-height: 60px;
        color: #fff;
        cursor: pointer;
        // margin: 20px;
        text-align: center;
        border: none;
        background-size: 300% 100%;

        border-radius: 5px;
        -moz-transition: all 0.4s ease-in-out;
        -o-transition: all 0.4s ease-in-out;
        -webkit-transition: all 0.4s ease-in-out;
        transition: all 0.4s ease-in-out;

        background-image: linear-gradient(
          to right,
          #f00,
          #c11616,
          #fe0404,
          #a11
        );
        box-shadow: 0 3px 10px 0 rgba(198, 24, 24, 0.75);

        &:hover {
          background-position: 100% 0;
          -moz-transition: all 0.4s ease-in-out;
          -o-transition: all 0.4s ease-in-out;
          -webkit-transition: all 0.4s ease-in-out;
          transition: all 0.4s ease-in-out;
        }
      }
    }

    div.downloadGame {
      margin-right: 90px;

      a {
        background-image: linear-gradient(
          to right,
          #fcc512,
          #fb9a0f,
          #fbba0f,
          #f60
        );
        box-shadow: 0 3px 10px 0 rgba(229, 198, 10, 0.75);
        color: #333;
      }
    }
  }
}
span.mousegif {
  height: 64px;
  width: 80px;
  display: inline-block;
  -webkit-animation: bounce-down 1.6s linear infinite;
  animation: bounce-down 1.6s linear infinite;
  position: fixed;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: auto;
  // z-index: 1000;

  img {
    width: 60px;
    -webkit-opacity: 0.5;
    opacity: 0.5;
  }

  .container {
    display: flex;
    justify-content: center;
    margin-top: 10%;
    width: 100%;
    height: 100vh;
  }
  .arrow {
    position: absolute;
    width: 3rem;
    height: 0.48rem;
    opacity: 0;
    transform: scale(0.3);
    animation: move-arrow 3s ease-out infinite;

    &:first-child {
      animation: move-arrow 3s ease-out 1s infinite;
    }
    &:nth-child(2) {
      animation: move-arrow 3s ease-out 2s infinite;
    }
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 0;
      height: 100%;
      width: 50%;
      background: #f8f8f8;
    }
    &:before {
      left: 0;
      transform: skewY(30deg);
    }
    &:after {
      right: 0;
      width: 50%;
      transform: skewY(-30deg);
    }
  }
}
@keyframes move-arrow {
  25% {
    opacity: 1;
  }
  33.3% {
    opacity: 1;
    transform: translateY(2rem);
  }
  66.6% {
    opacity: 1;
    transform: translateY(3.12rem);
  }
  100% {
    opacity: 0;
    transform: translateY(4.8rem) scale(0.5);
  }
}

@-webkit-keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-4px);
  }
  50%,
  100% {
    -webkit-transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(4px);
  }
}

@keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-4px);
  }
  50%,
  100% {
    -webkit-transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(4px);
  }
}

.xms {
  background: url("../assets/img/xms.jpg") no-repeat top center;
  height: 899px;
  position: relative;
  min-width: 1200px;
}
.xwf {
  background: #000;
  height: 900px;
  position: relative;
  width: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue